import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchPortalMe, type PortalMe } from '@/lib/api/portal'

/**
 * A identidade do portal: quem está autenticado e a que cliente pertence.
 *
 * Existe como hook — em vez de um `useQuery` escrito em cada sítio — porque
 * **duas superfícies leem o MESMO facto**: a barra do portal (o marcador de
 * quem é o cliente, que é chrome) e a tela de entrada. Com a chave declarada
 * aqui, o TanStack Query resolve as duas com **uma** ida à rede; com a chave
 * escrita duas vezes, bastava uma letra diferente para passarem a ser duas
 * caches, dois pedidos e — no pior caso — dois nomes de cliente diferentes na
 * mesma página.
 *
 * `retry: false` é deliberado e igual ao do `/api/me`: as recusas que esta
 * chamada produz (401 sessão morta, 403 fora da fronteira) não melhoram com
 * insistência. Quem quiser tentar de novo tem o botão da tela.
 */
export const PORTAL_ME_QUERY_KEY = ['portal', 'me'] as const

export function usePortalIdentity(): UseQueryResult<PortalMe, Error> {
  return useQuery({
    queryKey: PORTAL_ME_QUERY_KEY,
    queryFn: ({ signal }) => fetchPortalMe({ signal }),
    staleTime: 60_000,
    retry: false,
  })
}
